import { CPFUtil } from './CpfUtil'

export class StringHelper {
	static pluralizeWord(word: string, quantity: number): string {
		if (quantity === 1) {
			return word
		}

		if (word.endsWith('s') || word.endsWith('z') || word.endsWith('r')) {
			return word + 'es'
		}

		if (word.endsWith('ão')) {
			return word.slice(0, -2) + 'ões'
		}

		if (word.endsWith('l')) {
			return word.slice(0, -1) + 'is'
		}

		if (word.endsWith('m')) {
			return word.slice(0, -1) + 'ns'
		}

		return word + 's'
	}

	static copyToClipboard(text: string) {
		navigator.clipboard.writeText(text)
	}

	static padCnpj(value: string): string {
		// Remove a máscara e normaliza para maiúsculas (forma canônica raw),
		// reutilizando CPFUtil.cleanCnpj para evitar divergência de regex.
		const cleaned = CPFUtil.cleanCnpj(value)
		// CNPJ numérico legado pode ter perdido zeros à esquerda — completa só
		// quando não houver letras. Alfanumérico (IN RFB 2229/2024) passa intacto.
		if (/^\d*$/.test(cleaned)) return cleaned.padStart(14, '0')
		return cleaned
	}
}
